import imageCompression from "browser-image-compression";

const MultiImagesCompress = async (imagesFiles) => {

    const compressedImages = [];

    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    }

    for(let i = 0; i < imagesFiles.length; i++){

        const imageFile = imagesFiles[i];

        try {
        if(imageFile.type.includes('image')){
            const compressedFile = await imageCompression(imageFile, options);
            compressedImages.push(compressedFile)
        } else {
            compressedImages.push(imageFile);
        }
        } catch (error) {
        console.log(error);
        }
    }


    return compressedImages;
}

export default MultiImagesCompress;